export default `float s=5., e;
    p=p/dot(p,p)+1.;
    for(int i=0;i++<8;p*=e)
      p=1.-abs(p-1.),
      s*=e=1.6/min(dot(p,p),1.5);
    return length(cross(p,normalize(vec3(1.0))))/s-5e-4;
  }`